import styled from "styled-components";

export const CopyRightDivStyled = styled.div`
  .copyRightdiv {
    width: 100%;
    background: black;
    color: #747474;
    padding: 1em 0;
    justify-content: center;
    display: flex;
  }
  .nest {
    margin: 0 auto;
    position: relative;
    font-family: thin-pro, sans-serif;
  }
  .copy_content {
    margin: 0;
    font-family: thin-pro, sans-serif;
  }

  /* For large devices */
  @media screen and (max-width: 1440px) {
    .copyRightdiv {
      padding: 1em 10em;
    }
  }
  @media screen and (max-width: 1024px) {
    .copyRightdiv {
      padding: 1em 5em;
    }
  }

  /* For medium devices */
  @media screen and (max-width: 800px) {
    .copyRightdiv {
      padding: 1em 2em;
    }
  }
`;
